module.exports = __webpack_public_path__ + "img/BMD.8bdf2503.svg";